/* Cart Drawer Custom JavaScript */

var FREE_BOTTLE_CODE = 'FREE-UNIVERSAL-BOTTLE';
var _freeBottlePending = false;
var _freeBottleLastRun = 0;

// Returns true if there is a manually-entered discount code currently active in the cart
function hasActiveDiscountCode(cart) {
  return (
    (Array.isArray(cart.cart_level_discount_applications) &&
      cart.cart_level_discount_applications.some(function(d) { return d.type === 'discount_code'; })) ||
    (Array.isArray(cart.discount_applications) &&
      cart.discount_applications.some(function(d) { return d.type === 'discount_code'; }))
  );
}

// Repaint the free shipping progress bar for a given cart total (in cents).
// The drawer re-renders on quantity changes, so this is only needed for the
// in-place updates (discount code) that don't refetch the section.
function updateFreeShippingBar(totalPrice) {
  var bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return;
  var threshold = parseInt(bar.dataset.threshold, 10) || 0;
  if (threshold <= 0) return;

  var messageEl = bar.querySelector('[data-free-shipping-message]');
  var fillEl = bar.querySelector('[data-free-shipping-fill]');
  var trackEl = bar.querySelector('.free-shipping-bar__track');
  var remaining = Math.max(threshold - totalPrice, 0);
  var progress = Math.min(Math.round((totalPrice * 100) / threshold), 100);

  bar.classList.toggle('is-unlocked', remaining === 0);
  if (fillEl) fillEl.style.width = progress + '%';
  if (trackEl) trackEl.setAttribute('aria-valuenow', progress);
  if (messageEl) {
    if (remaining === 0) {
      messageEl.innerHTML = bar.dataset.unlockedHtml || '';
    } else {
      var formatted = (remaining / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      });
      messageEl.innerHTML = (bar.dataset.remainingTemplate || '__amount__').replace('__amount__', formatted);
    }
  }
}

// Refresh the cart drawer HTML and subtotal in-place (keeps active/animate classes).
function refreshCartDrawer() {
  var base = window.location.pathname.replace(/\/$/, '') || '';
  return fetch(base + '?section_id=cart-drawer&_cb=' + Date.now(), { cache: 'no-store' })
    .then(function(r) { return r.text(); })
    .then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newDrawerEl = doc.querySelector('cart-drawer');
      var cartDrawerEl = document.querySelector('cart-drawer');
      if (newDrawerEl && cartDrawerEl) {
        cartDrawerEl.innerHTML = newDrawerEl.innerHTML;
        if (newDrawerEl.classList.contains('is-empty')) {
          cartDrawerEl.classList.add('is-empty');
        } else {
          cartDrawerEl.classList.remove('is-empty');
        }
      }
    })
    .catch(function() {});
}

// Apply FREE-UNIVERSAL-BOTTLE only if no other discount code is currently active.
// Used on page load and every time the cart drawer opens (handles checkout removal case).
// refreshOnApply: when true, refreshes the cart drawer HTML after applying the code.
function maybeApplyFreeBottle(refreshOnApply) {
  if (window.kenckoCustomerHasOrders) return;
  if (_freeBottlePending) return;
  // Debounce: skip if we ran within the last 5 seconds to avoid request bursts on cart add
  var now = Date.now();
  if (now - _freeBottleLastRun < 5000) return;
  _freeBottlePending = true;
  _freeBottleLastRun = now;

  fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!hasActiveDiscountCode(cart)) {
        return fetch('/discount/' + FREE_BOTTLE_CODE, { credentials: 'same-origin' })
          .then(function() {
            if (refreshOnApply) return refreshCartDrawer();
          });
      }
    })
    .catch(function() {})
    .then(function() { _freeBottlePending = false; });
}

// Apply on page load
maybeApplyFreeBottle();

document.addEventListener('DOMContentLoaded', function() {
  // Add styles to body when cart drawer is active
  const cartDrawer = document.querySelector('cart-drawer');
  
  if (cartDrawer) {
    // Watch for class changes on cart-drawer
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'class') {
          const hasActiveClass = cartDrawer.classList.contains('active');
          
          if (hasActiveClass) {
            document.body.style.overflow = 'hidden';
            // Re-apply FREE-UNIVERSAL-BOTTLE if no code is active (handles checkout removal case)
            maybeApplyFreeBottle(true);
          } else {
            document.body.style.overflow = '';
          }
        }
      });
    });
    
    observer.observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  // Toggle icon between minus and trash based on quantity
  function updateMinusButtonIcon(quantityInput) {
    const quantityValue = parseInt(quantityInput.value);
    const minusButton = quantityInput.closest('quantity-input').querySelector('button[name="minus"]');
    
    if (minusButton) {
      const minusIcon = minusButton.querySelector('.svg-minus');
      const trashIcon = minusButton.querySelector('.svg-trash');
      
      if (quantityValue === 1) {
        if (minusIcon) minusIcon.style.display = 'none';
        if (trashIcon) trashIcon.style.display = '';
      } else {
        if (minusIcon) minusIcon.style.display = '';
        if (trashIcon) trashIcon.style.display = 'none';
      }
    }
  }

  // Update icons on page load
  document.querySelectorAll('.quantity__input').forEach(function(input) {
    updateMinusButtonIcon(input);
  });

  // Update icons when quantity changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('quantity__input')) {
      updateMinusButtonIcon(e.target);
    }
  });

  // Discount Code Handler — uses event delegation so it works after DOM re-renders
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter') return;
    if (e.target.id !== 'CartDrawer-DiscountInput') return;
    var btn = document.getElementById('CartDrawer-DiscountButton');
    if (btn) btn.click();
  });

  document.addEventListener('click', async function(e) {
    var discountButton = e.target.closest('#CartDrawer-DiscountButton');
    if (!discountButton) return;

    var discountInput = document.getElementById('CartDrawer-DiscountInput');
    if (!discountInput) return;

    var code = discountInput.value.trim();

    if (!code) {
      var messageEl = document.getElementById('CartDrawer-DiscountMessage');
      if (messageEl) {
        messageEl.textContent = discountButton.dataset.errorLabel || 'Invalid or expired discount code.';
        messageEl.style.color = 'red';
      }
      return;
    }

    discountButton.disabled = true;
    var applyLabel = discountButton.dataset.applyLabel || discountButton.textContent;
    discountButton.dataset.applyLabel = applyLabel;
    discountButton.textContent = '...';

    var msgElBefore = document.getElementById('CartDrawer-DiscountMessage');
    if (msgElBefore) msgElBefore.textContent = '';

    try {
      // Snapshot total before — comparing before/after is the only reliable way to detect
      // if the code actually reduced the price (original_total_price includes subscription
      // plan discounts which makes it unreliable as a baseline)
      var beforeRes = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' });
      var beforeCart = await beforeRes.json();
      var beforeTotal = beforeCart.total_price;

      await fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' });

      var afterRes = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' });
      var cart = await afterRes.json();

      var applied = cart.total_price < beforeTotal;

      // Re-fetch messageEl in case DOM was re-rendered during async calls
      var messageEl = document.getElementById('CartDrawer-DiscountMessage');

      if (applied) {
        if (messageEl) {
          messageEl.textContent = discountButton.dataset.successLabel || 'Discount applied!';
          messageEl.style.color = 'green';
        }
        var subtotalEl = document.getElementById('CartDrawer-Subtotal');
        var currency = cart.currency || 'USD';
        var formatMoney = function (cents) {
          return (cents / 100).toLocaleString('en-US', {
            style: 'currency',
            currency: currency
          });
        };
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
        // Keep the struck-through full price and the "You saved" line in sync with the new total
        var subtotalWrapper = document.querySelector('.cart-drawer__subtotal');
        var compareEl = document.getElementById('CartDrawer-SubtotalCompare');
        var savingsEl = document.getElementById('CartDrawer-Savings');
        if (subtotalWrapper && compareEl && savingsEl) {
          var fullTotal = parseInt(subtotalWrapper.dataset.fullTotal, 10) || 0;
          var savings = fullTotal - cart.total_price;
          if (savings > 0) {
            var savingsTemplate = savingsEl.dataset.savingsTemplate || '__amount__';
            compareEl.textContent = formatMoney(fullTotal);
            savingsEl.textContent = savingsTemplate.replace('__amount__', formatMoney(savings));
            compareEl.hidden = false;
            savingsEl.hidden = false;
          } else {
            compareEl.hidden = true;
            savingsEl.hidden = true;
          }
        }
        updateFreeShippingBar(cart.total_price);
      } else {
        if (messageEl) {
          messageEl.textContent = discountButton.dataset.errorLabel || 'Invalid or expired discount code.';
          messageEl.style.color = 'red';
        }
        // The invalid code may have replaced FREE-UNIVERSAL-BOTTLE in the session.
        // maybeApplyFreeBottle checks the cart and restores it if no valid code is now active.
        maybeApplyFreeBottle();
      }
    } catch (err) {
      var messageEl = document.getElementById('CartDrawer-DiscountMessage');
      if (messageEl) {
        messageEl.textContent = discountButton.dataset.networkErrorLabel || 'Error applying discount. Please try again.';
        messageEl.style.color = 'red';
      }
    } finally {
      discountButton.disabled = false;
      discountButton.textContent = discountButton.dataset.applyLabel || 'apply';
    }
  });

  // Update icons after cart updates
  document.addEventListener('cart:update', function() {
    setTimeout(function() {
      document.querySelectorAll('.quantity__input').forEach(function(input) {
        updateMinusButtonIcon(input);
      });
    }, 300);
  });

  // Show removing state when clicking trash (minus at qty=1) on regular items
  document.addEventListener('click', function(e) {
    var minusBtn = e.target.closest('quantity-input button[name="minus"]');
    if (!minusBtn) return;
    var trashIcon = minusBtn.querySelector('.svg-trash');
    if (!trashIcon || trashIcon.style.display === 'none') return;
    var cartItem = minusBtn.closest('.cart-item');
    if (cartItem) {
      cartItem.style.transition = 'opacity 0.15s';
      cartItem.style.opacity = '0.4';
      cartItem.style.pointerEvents = 'none';
    }
  });

  // ─── Quantity loading state ───────────────────────────────────────────────
  // Cart updates go through the network and can take a moment; dim the line
  // item and swap its quantity widget for a spinner so the change is visible.
  function setQuantityLoading(el, isLoading) {
    if (!el) return;
    var quantityEl = el.closest('.quantity');
    var cartItem = el.closest('.cart-item');
    if (quantityEl) quantityEl.classList.toggle('is-updating', isLoading);
    if (cartItem) cartItem.classList.toggle('is-updating', isLoading);
  }

  // Regular (non-bundled) items — the request itself is handled by cart.js,
  // and the drawer re-renders when it's done, which clears the state.
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('quantity-input button[name="minus"], quantity-input button[name="plus"]');
    if (!btn || !btn.closest('cart-drawer')) return;
    if (btn.classList.contains('disabled') || btn.disabled) return;
    setQuantityLoading(btn, true);
  });

  document.addEventListener('change', function(e) {
    var input = e.target.closest('.quantity__input');
    if (!input || !input.closest('cart-drawer')) return;
    setQuantityLoading(input, true);
  });

  // Box (bundled) quantity handlers
  var _boxUpdateInProgress = false;

  document.addEventListener('click', async function(e) {
    var minusBtn = e.target.closest('[data-box-minus]');
    var plusBtn = e.target.closest('[data-box-plus]');
    if (!minusBtn && !plusBtn) return;
    if (_boxUpdateInProgress) return;

    var btn = minusBtn || plusBtn;
    var boxGroup = btn.getAttribute('data-box-group');

    var quantityEl = btn.closest('.quantity');
    if (!quantityEl) return;
    var countDisplay = quantityEl.querySelector('.box-quantity-display');
    if (!countDisplay) return;

    var currentCount = parseInt(countDisplay.textContent, 10) || 1;
    var newCount = minusBtn ? currentCount - 1 : currentCount + 1;
    if (newCount < 0) return;

    setQuantityLoading(btn, true);

    // Always fetch fresh cart state so we use current keys, not potentially stale HTML attributes
    var liveCart;
    try {
      var cartRes = await fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' });
      liveCart = await cartRes.json();
    } catch (err) {
      console.error('Error fetching cart:', err);
      setQuantityLoading(btn, false);
      return;
    }

    // Build changes from live cart items that belong to this box group
    var changes = [];
    var groupItems = liveCart.items.filter(function(item) {
      return item.properties && item.properties['_box_group'] === boxGroup;
    });

    if (groupItems.length === 0) {
      setQuantityLoading(btn, false);
      return;
    }

    // Derive base qty per item from _box_qty property (fallback to current quantity)
    groupItems.forEach(function(item) {
      var baseQty = parseInt(item.properties['_box_qty'], 10) || item.quantity;
      changes.push({ id: item.key, quantity: newCount * baseQty });
    });

    // When removing the box entirely, also remove its linked hidden offer item
    if (newCount === 0) {
      liveCart.items.forEach(function(item) {
        if (item.properties && item.properties['_offer_for'] === boxGroup) {
          changes.push({ id: item.key, quantity: 0 });
        }
      });
    }

    _boxUpdateInProgress = true;
    document.querySelectorAll('[data-box-minus], [data-box-plus]').forEach(function(b) { b.disabled = true; });

    if (newCount === 0) {
      var cartItemEl = btn.closest('.cart-item');
      if (cartItemEl) {
        cartItemEl.style.transition = 'opacity 0.15s';
        cartItemEl.style.opacity = '0.4';
        cartItemEl.style.pointerEvents = 'none';
      }
    }

    try {
      // Send all quantity changes in a single atomic request
      var updates = {};
      changes.forEach(function(change) { updates[change.id] = change.quantity; });
      var updateRes = await fetch((window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ updates: updates })
      });
      if (!updateRes.ok) {
        console.error('Cart update failed:', await updateRes.text());
      }

      // Refresh drawer content via innerHTML to preserve the element (keeps active/animate classes)
      var sectionBase = window.location.pathname.replace(/\/$/, '') || '';
      var sectionRes = await fetch(sectionBase + '?section_id=cart-drawer&_cb=' + Date.now(), { cache: 'no-store' });
      var sectionHtml = await sectionRes.text();
      var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      var newDrawerEl = doc.querySelector('cart-drawer');
      var cartDrawerEl = document.querySelector('cart-drawer');

      if (newDrawerEl && cartDrawerEl) {
        cartDrawerEl.innerHTML = newDrawerEl.innerHTML;
        if (newDrawerEl.classList.contains('is-empty')) {
          cartDrawerEl.classList.add('is-empty');
        } else {
          cartDrawerEl.classList.remove('is-empty');
        }
      } else {
        console.warn('Cart drawer element not found after re-render, forcing page reload');
        window.location.reload();
      }

      // Update cart icon bubble count
      var iconRes = await fetch(sectionBase + '?section_id=cart-icon-bubble&_cb=' + Date.now(), { cache: 'no-store' });
      var iconHtml = await iconRes.text();
      var iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html');
      var cartIconBubble = document.querySelector('#cart-icon-bubble');
      if (cartIconBubble) {
        var oldBubble = cartIconBubble.querySelector('.cart-count-bubble');
        if (oldBubble) oldBubble.remove();
        var newBubble = iconDoc.querySelector('.cart-count-bubble');
        if (newBubble) cartIconBubble.appendChild(newBubble);
      }
    } catch (err) {
      console.error('Box quantity update failed:', err);
      window.location.reload();
    } finally {
      _boxUpdateInProgress = false;
      // Buttons disabled by the template (e.g. limited-quantity promo) stay disabled
      document.querySelectorAll('[data-box-minus], [data-box-plus]').forEach(function(b) {
        if (b.getAttribute('aria-disabled') !== 'true') b.disabled = false;
      });
      // The drawer is re-rendered on success, so this only matters when it isn't
      setQuantityLoading(btn, false);
    }
  });

});
